const languages = [
  {
    id: 'en-us',
    currencyCode: 'USD',
  },
];

export default languages;